import { Check } from "lucide-react";

const STEPS = [
  { key: "proposal", label: "Proposal" },
  { key: "loe", label: "Engagement" },
  { key: "welcome", label: "Welcome" },
];

// package stage counts as part of the proposal step
const STAGE_INDEX = { package: 0, proposal: 0, loe: 1, welcome: 2 };

export default function StageProgress({ stage }) {
  const active = STAGE_INDEX[stage] ?? 0;
  return (
    <div className="flex items-center justify-center gap-2 mb-6" data-testid="stage-progress">
      {STEPS.map((s, i) => {
        const done = i < active;
        const current = i === active;
        return (
          <div key={s.key} className="flex items-center gap-2">
            <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium transition-colors
              ${current ? "bg-cass-navy text-white" : done ? "bg-cass-teal/15 text-cass-teal" : "bg-white text-cass-slate border border-border"}`}
              data-testid={`stage-step-${s.key}`}>
              <span className={`w-5 h-5 grid place-items-center rounded-full text-xs font-bold
                ${current ? "bg-cass-teal text-white" : done ? "bg-cass-teal text-white" : "bg-slate-200 text-cass-slate"}`}>
                {done ? <Check className="w-3 h-3" /> : i + 1}
              </span>
              <span className="hidden sm:inline">{s.label}</span>
            </div>
            {i < STEPS.length - 1 && <div className={`w-6 h-px ${done ? "bg-cass-teal" : "bg-border"}`} />}
          </div>
        );
      })}
    </div>
  );
}
